let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1RQpE")).then(() => parcelRequire('fMeA7'));